import React from "react";
import { Link } from "react-router-dom";
import "./ThankYou.css";

function ThankYou() {
  return (
    <section className="hmslder-sec abt-sec thankyou-sec">
      {/* Breadcrumbs */}
      <div className="breadcrumbs">
        <div className="container">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li>Thank You</li>
          </ul>
        </div>
      </div>

      <div className="container">
        {/* Heading */}
        <div className="hmslder-txt">
          <h2>Thank <span>You</span></h2>
          <p>
            We appreciate you getting in touch with us.  
            Your request has been submitted successfully and our team will
            contact you shortly.
          </p>

          <Link to="/" className="btn-main">
              <span>Go Back to Home</span>
            </Link>
        </div>
      </div>
    </section>
  );
}

export default ThankYou;
